<template>
  <div class="pdf-viewer">
    <div class="pdf-viewer-container" ref="pdfContainer">
      <pdf
        ref="pdf"
        :page="currentPage"
        :src="src"
        @num-pages="pageCount = $event"
        @page-loaded="currentPage = $event"
        @progress="progress"
      ></pdf>
    </div>
    <div class="pdf-viewer-control">
      <el-button @click="prev">上一页</el-button>
      <div class="pdf-viewer-control-page">
        <el-input-number v-model="currentPage" controls-position="right" :min="1" :max="pageCount"></el-input-number>
        &nbsp;/
        {{ pageCount }}
      </div>
      <el-button @click="next">下一页</el-button>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  name: 'PdfViewer',
  components: {
    pdf,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 0,
    }
  },
  watch:{
    currentPage(){
      this.$nextTick(()=>{
        this.$refs.pdfContainer.scrollTop=0
      })
    }
  },
  created() {
    this.currentPage =1
  },
  methods: {
    progress(e) {
      this.currentPage = e
      console.log(e)
    },
    prev() {
      if(this.currentPage>1){
        this.currentPage--
      }
    },
    next() {
      if(this.currentPage<this.pageCount){
        this.currentPage++
      }
    },
  },
}
</script>

<style lang="less" scoped>
.pdf-viewer {
  position: relative;
  height: 100%;
  &-container {
    height: calc(100% - 80px);
    overflow-y: scroll;
    &::-webkit-scrollbar{
      width: 10px;
      height: 10px;
      background-color: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb{
      background-color: #bbb;
      border-radius: 5px;
      &:hover{
        background-color: #999;
      }
    }
  }
  &-control {
    width: 100%;
    height: 80px;
    background-color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    &-page {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 20px;
      font-size: 20px;
      /deep/ .el-input-number{
        width: 80px;
        .el-input-number__decrease,.el-input-number__increase{
          display: none;
        }
        .el-input__inner{
          padding-right: 15px;
          text-align: center;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PdfViewer/index.vue